var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersDetailsForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2958_20546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 11,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54036 7.58357L10.0562 7.58357L7.20953 10.4302C6.98203 10.6577 6.98203 11.0311 7.20953 11.2586C7.43703 11.4861 7.80453 11.4861 8.03203 11.2586L11.8762 7.41441C12.1037 7.18691 12.1037 6.81941 11.8762 6.59191L8.03787 2.74191C7.92888 2.63267 7.78092 2.57129 7.62662 2.57129C7.47231 2.57129 7.32435 2.63267 7.21536 2.74191C6.98786 2.96941 6.98786 3.33691 7.21536 3.56441L10.0562 6.41691L3.54036 6.41691C3.21953 6.41691 2.95703 6.67941 2.95703 7.00024C2.95703 7.32107 3.21953 7.58357 3.54036 7.58357Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2958_20546)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 14,
    height: 14,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersDetailsForwardArrow);
export default __webpack_public_path__ + "static/media/orders-details-ForwardArrow.08908333950becb658bb8964d5b0ccb3.svg";
export { ForwardRef as ReactComponent };